import classnames from 'classnames';
import React from 'react';

import { BlankButton } from './BlankButton';
import { t } from './i18n/i18n';

interface CouponCopyButtonProps {
  code?: string;
}

export const CouponCopyButton = ({ code }: CouponCopyButtonProps) => {
  const [copied, setCopied] = React.useState(false);

  const handleClick = React.useCallback(() => {
    if (code) {
      navigator.clipboard.writeText(code).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      });
    }
  }, [code]);

  return (
    <BlankButton
      aria-label={copied ? undefined : t('account.coupons.copyCode', { code })}
      aria-live="polite"
      className={classnames({ 'text-decoration-underline': !copied }, 'small')}
      onClick={handleClick}
    >
      {copied ? t('account.coupons.copied') : t('account.coupons.copy')}
    </BlankButton>
  );
};
